import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-968dae10"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ssh-status-bar" }, null, -1))
const _hoisted_2 = { class: "ssh-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ssh-connect-dlg" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ssh-start-info" }, "Connecting to SSH...")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ssh-terminal-container" }, null, -1))

import { onMounted, onUnmounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { useI18n } from 'vue-i18n'
import dayjs from 'dayjs'
import { interval } from 'rxjs'
import { Severity, SshTerminalService } from './ssh-terminal.service'
import { sshDeviceStore } from '@/services/remote-device.service'
import {
  ConnectStateRes, DEBUG_REMOTE, REMOTE_STATE,
  REMOTE_TYPE,
  RemoteAssistService,
  VncDevice
} from '@/views/dashboard/group/client/modals/remote-assist/remote-assist.service'
import SshDisconnectBtn from './_components/ssh-disconnect-btn.vue'
import { useBrandCustomStore } from '@/services/brand-custom.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'remote-ssh',
  setup(__props) {

const { t } = useI18n()

const route = useRoute()
const injector = useReflectiveInjector([SshTerminalService, RemoteAssistService])
const remoteAssistService = injector.get(RemoteAssistService)
const sshTerminalService = injector.get(SshTerminalService)
const statusTimer = ref(null)
const connectInfo = ref({} as VncDevice)
const containerRef = ref<HTMLElement>()

function updateConnectInfo () {
  connectInfo.value = sshDeviceStore.getDevice(route.query.device_id as string)
}

function loopDeviceStatus () {
  statusTimer.value = interval(3000).subscribe(() => {
    remoteAssistService.getConnectState({
      device_id: connectInfo.value.device_id,
      remote_type: REMOTE_TYPE.REMOTE_ASSIST
    }).then((res: ConnectStateRes) => {
      if (res.connect_status === REMOTE_STATE.IDLE && sshTerminalService.isConnected()) {
        console.log('检测到服务端已断开远控，因此前端主动关闭WS连接')
        sshTerminalService.disconnect()
      }
    }).catch((error) => {
      const ret = error.responseBody?.ret // 取消http全局错误事件
    })
  })
}

function httpStateErrorBlock (error) {
  const ret = error.responseBody?.ret // 取消http全局错误事件
  const tipsText = '请勿使用他人的远控链接。请关闭此页面后，使用团队管理平台页面操作进行远控'
  if (+localStorage.getItem(DEBUG_REMOTE) === 1) {
    startConnect()
    return
  }

  if (!connectInfo.value?.ws_url) {
    sshTerminalService.showMsg(`远控信息缺失，${tipsText}。`, 0, Severity.ERROR)
  } else {
    sshTerminalService.showMsg(`连接失败，${tipsText}。`, 0, Severity.ERROR)
  }
}

function pagehide () {
  console.log('检测到远控窗口卸载(短时间重新访问可重连)，因此前端只主动关闭WS连接')
  sshTerminalService.disconnect()
  sshDeviceStore.replaceDevice({ ...connectInfo.value, unload_timestamp: dayjs().valueOf() })
}

function beforeUnload(e: BeforeUnloadEvent) {
  const message = '确定要离开此页面吗？SSH连接将会断开。'
  e.preventDefault()
  e.returnValue = message
  return message
}

function startConnect () {
  loopDeviceStatus()
  sshTerminalService.startConnection(connectInfo.value.ws_url)
  sshDeviceStore.replaceDevice({ ...connectInfo.value, unload_timestamp: undefined })
  remoteAssistService.reportHeartbeat(connectInfo.value.device_id)
  window.addEventListener('beforeunload', beforeUnload)
  window.addEventListener('pagehide', pagehide)
  window.addEventListener('storage', updateConnectInfo)
}

function initPage () {
  remoteAssistService.getConnectState({
    device_id: connectInfo.value.device_id,
    remote_type: REMOTE_TYPE.REMOTE_ASSIST
  }).then(() => {
    startConnect()
  }).catch(httpStateErrorBlock)
}

/** 处理断开连接 */
function handleDisconnect () {
  sshTerminalService.disconnect()
  statusTimer.value?.unsubscribe()
  remoteAssistService.turnOffSsh({
    device_id: connectInfo.value.device_id,
    token: connectInfo.value.token,
    room_id: connectInfo.value.room_id,
  }).catch((error) => {
    const ret = error.responseBody?.ret // 取消http全局错误事件
  })
  sshTerminalService.showMsg('连接已断开', 0, Severity.ERROR)
}

updateConnectInfo()

onMounted(() => {
  document.title = useBrandCustomStore().brandConfig.client_name + t('terminal.remoteAssistCardTitleAssist')
  sshTerminalService.initTerminal(containerRef.value)
  initPage()
})

onUnmounted(() => {
  statusTimer.value?.unsubscribe()
  sshTerminalService.disconnect()
  window.removeEventListener('beforeunload', beforeUnload)
  window.removeEventListener('pagehide', pagehide)
  window.removeEventListener('storage', updateConnectInfo)
  document.title = useBrandCustomStore().brandConfig.project_name
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "containerRef",
    ref: containerRef,
    class: "ssh-container"
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (0)
        ? (_openBlock(), _createBlock(SshDisconnectBtn, {
            key: 0,
            onDisconnect: handleDisconnect
          }))
        : _createCommentVNode("", true)
    ])
  ], 512))
}
}

})